import React, { useCallback, useEffect, useMemo } from 'react'
import { filter, find, isNil, map, some, toString } from 'lodash'
import PropTypes from 'prop-types'

import { GridFormItem } from '../../../core/components/sections'
import { useQueryParams } from '../../../core/hooks'
import { areSameValue, getFilterOptions } from '../../../core/utils'

import { Select } from '../../../common/components/sections'
import { StyledPaddingBottomRow } from '../../../common/components/styled'
import { ALL_SELECT_FILTER_ITEM, PAGINATION } from '../../../common/constants'
import { useUsersQuery } from '../../../common/hooks'

import { MENU_ALLOCATION_STATUS } from '../../constants'
import { useUserAllocationCountsLazyQuery } from '../../hooks'

const PriorityTaskMenuCurationTaskFilters = ({ priorityTaskId }) => {
  const {
    allocatedUserId,
    allocationStatus = null,
    setQueryParams,
  } = useQueryParams()

  const { data: usersData } = useUsersQuery()
  const [fetchAllocationCounts, { data: allocationCounts }] =
    useUserAllocationCountsLazyQuery()

  const usersOptions = useMemo(
    () => [
      ALL_SELECT_FILTER_ITEM,
      ...map(
        filter(usersData, user =>
          some(allocationCounts, ({ userId }) => areSameValue(userId, user.id)),
        ),
        ({ id, name }) => {
          const dishCount = find(allocationCounts, ({ userId }) =>
            areSameValue(userId, id),
          )

          return {
            label: `${name} (${dishCount.allocationCount})`,
            value: id,
          }
        },
      ),
    ],
    [allocationCounts, usersData],
  )
  const selectedAllocatedUser = useMemo(
    () => (!isNil(allocatedUserId) ? toString(allocatedUserId) : null),
    [allocatedUserId],
  )

  const allocationStatusOptions = useMemo(
    () => [
      ALL_SELECT_FILTER_ITEM,
      ...getFilterOptions(MENU_ALLOCATION_STATUS, 'label', 'value'),
    ],
    [],
  )

  const handleSetAllocatedUser = useCallback(
    value => {
      setQueryParams({
        currentPage: PAGINATION.DEFAULT_PAGE,
        allocatedUserId: value,
      })
    },
    [setQueryParams],
  )

  const handleSetAllocationStatus = useCallback(
    value => {
      setQueryParams({
        currentPage: PAGINATION.DEFAULT_PAGE,
        allocationStatus: value,
      })
    },
    [setQueryParams],
  )

  useEffect(() => {
    fetchAllocationCounts(priorityTaskId)
  }, [fetchAllocationCounts, priorityTaskId])

  return (
    <StyledPaddingBottomRow gutter={16}>
      <GridFormItem span={4} label="Allocated User">
        <Select
          allowClear
          showSearch
          options={usersOptions}
          value={selectedAllocatedUser}
          onChange={handleSetAllocatedUser}
        />
      </GridFormItem>
      <GridFormItem span={4} label="Allocation Status">
        <Select
          allowClear
          showSearch
          options={allocationStatusOptions}
          value={allocationStatus}
          onChange={handleSetAllocationStatus}
        />
      </GridFormItem>
    </StyledPaddingBottomRow>
  )
}

PriorityTaskMenuCurationTaskFilters.propTypes = {
  priorityTaskId: PropTypes.string.isRequired,
}

export default PriorityTaskMenuCurationTaskFilters
